module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n\r\n/* .text-rotation{\r\n transform: rotate(270deg); \r\n     width: 150px;\r\n  height: 100px; \r\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/service-register-views/service-reg-view-form/service-reg-view-form.component.css
// module id = ./src/app/hrms/serviceregister/service-register-views/service-reg-view-form/service-reg-view-form.component.css
// module chunks = main